module.exports = "<th ng-repeat=\"col in datagridCtrl.cols\">\n\t{{col.label}}\n\t<button class=\"btn btn-xs glyphicon\"\n\t ng-click=\"datagridCtrl.headerSort(col.key)\"\n\t ng-class=\"{'glyphicon-triangle-bottom':!datagridCtrl.desc, 'glyphicon-triangle-top':datagridCtrl.desc}\"></button>\n</th>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/demo/partials/datagrid/sort-header-cell.html
 ** module id = 127
 ** module chunks = 1
 **/